import {analyticsLogEvent} from '../api'

const eventName = 'user_data'

interface UserDataParameters {
    login: string
    visitorId: string
    cartItemNumber: string
}

/**
 * Tracks a user data event; it must be triggered at every page load.
 *
 * @param {Object} params - The parameters object.
 * @param {boolean} params.isLogged - Indicates if the user is logged or not.
 * @param {string} params.visitorId - Returns the clientId.
 * @param {number} params.cartItemNumber - Indicates how much items are in the cart.
 */
export function analyticsUserData({isLogged, clientId, basketProductsLength}: {isLogged: boolean; clientId: string; basketProductsLength: number}): void {
    const eventDetails: UserDataParameters = {
        login: String(isLogged),
        visitorId: clientId,
        cartItemNumber: String(basketProductsLength),
    }

    analyticsLogEvent(eventName, eventDetails)
}
